import {debounce} from 'lodash';
import React, {useCallback, useState} from 'react';
import {useSelector} from 'react-redux';
import {DateRangePicker} from 'rsuite';

const Filters = ({filters, setFilters, setPagination, pageType = 'non-view'}) => {
  const [value, setValue] = useState(null);

  const procedures = useSelector(state => state.inPatientSchedule.procedures);
  const hospitals = useSelector(state => state.inPatientSchedule.hospitals);

  const status = {
    pending: 'Pending',
    complete: 'Complete',
    cancel: 'Cancel'
  };

  const isClearDisabled = !(filters.search || filters.procedure || filters.hospital || filters.status || filters.payment_status || filters.admission_date_after || filters.admission_date_before);

  const handleInputChange = e => {
    const {name, value} = e.target;
    setFilters(prev => ({...prev, [name]: value}));
  };

  const handleDateChange = newValue => {
    setValue(newValue);

    if (newValue?.length === 2) {
      const [start, end] = newValue;

      const startDate = new Date(start);
      const endDate = new Date(end);

      startDate.setHours(0, 0, 0, 0);

      endDate.setHours(23, 59, 59, 999);

      const startIso = startDate.toISOString();
      const endIso = endDate.toISOString();

      setFilters(prev => ({
        ...prev,
        admission_date_after: startIso,
        admission_date_before: endIso
      }));
    } else {
      setFilters(prev => ({
        ...prev,
        admission_date_after: '',
        admission_date_before: ''
      }));
    }
  };

  const handleSearchChange = useCallback(
    debounce(value => {
      setFilters(prev => ({...prev, search: value}));
      setPagination(prev => ({...prev, pageIndex: 1})); // Reset to first page on search
    }, 500),
    []
  );

  const clearAllFilters = () => {
    setFilters({
      search: '',
      procedure: '',
      hospital: '',
      status: '',
      payment_status: '',
      admission_date_after: '',
      admission_date_before: ''
    });
    setValue([]);
    setPagination({pageIndex: 1});
  };

  return (
    <div className='filters-container' style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
      {pageType === 'non-view' ? (
        <div className='input-group rounded' style={{width: '250px', height: '40px'}}>
          <input
            type='search'
            className='form-control rounded'
            aria-label='Search drugs'
            placeholder='Search...'
            value={filters.search}
            onChange={e => handleSearchChange(e.target.value)}
            style={{height: '40px'}}
          />

          <span className='input-group-text border-0 bg-transparent p-0'>
            <i className='bi bi-search' style={{color: '#1b5a90', width: '20px', height: '20px', marginLeft: '10px'}}></i>
          </span>
        </div>
      ) : (
        <>
          <div className='row'>
            <div className='col-3 col-md-3'>
              <label className='form-label'>From - To</label>
              <DateRangePicker
                value={value}
                onChange={handleDateChange}
                placeholder='Select Date Range'
                appearance='default'
                className='w-100 custom-date-picker'
                format='dd-MM-yyyy'
                shouldDisableDate={date => false}
              />
            </div>
            <div className='col-3 col-md-3'>
              <label className='form-label'>Procedure</label>
              <select className='form-select' name='procedure' value={filters.procedure} onChange={handleInputChange}>
                <option value=''>Select Procedure</option>
                {procedures.map(proc => (
                  <option key={proc.id} value={proc.name}>
                    {proc.name}
                  </option>
                ))}
              </select>
            </div>

            <div className='col-3 col-md-2'>
              <label className='form-label'>Hospital</label>
              <select className='form-select' name='hospital' value={filters.hospital} onChange={handleInputChange}>
                <option value=''>Select Hospital</option>
                {hospitals.map(hospital => (
                  <option key={hospital.id} value={hospital.name}>
                    {hospital.name}
                  </option>
                ))}
              </select>
            </div>
            <div className='col-3 col-md-2'>
              <label className='form-label'>Status</label>
              <select className='form-select' name='status' value={filters.status} onChange={handleInputChange}>
                <option value=''>Select Status</option>
                {Object.entries(status).map(([key, label]) => (
                  <option key={key} value={key}>
                    {label}
                  </option>
                ))}
              </select>
            </div>
            <div className='col-3 col-md-2'>
              <label className='form-label'>Paid</label>
              <select className='form-select' name='payment_status' value={filters.payment_status} onChange={handleInputChange}>
                <option value=''>Select Paid/Unpaid</option>
                <option value='true'>Paid</option>
                <option value='false'>Unpaid</option>
              </select>
            </div>
          </div>
          <div style={{textAlign: 'right'}}>
            <button className='btn btn-primary' onClick={clearAllFilters} disabled={isClearDisabled}>
              Clear All Filters
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Filters;
